import { IconSearch } from '@tabler/icons-react'
import clsx from 'clsx'
import { TextInput, TextInputProps } from '@mantine/core'
import classes from './search.module.css'
import { SEARCH_LIMIT } from '@/pages/stations/constants'
import { useStationSearch } from '@/hooks/use-station-search'

export const Search = ({ fullWidth, ...props }: TextInputProps & { fullWidth?: boolean }) => {
  const searchClasses = clsx(classes.input, { [classes.inputFullWidth]: fullWidth })

  const { searchTermEntry, setSearchTermEntry, handleSearchRequest } =
    useStationSearch(SEARCH_LIMIT)

  return (
    <TextInput
      aria-label='Search'
      type='search'
      size='sm'
      leftSectionPointerEvents='none'
      leftSection={<IconSearch className={classes.searchIcon} />}
      classNames={{
        root: searchClasses,
      }}
      placeholder='Search stations'
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleSearchRequest()
        }
      }}
      onChange={(e) => setSearchTermEntry(e.currentTarget.value)}
      value={searchTermEntry}
      {...props}
    />
  )
}
